import React from "react";
import ShareIcon from "@/components/icons/ShareIcon";
import LifetimeIcon from "@/components/icons/LifetimeIcon";
import { cn } from "@/lib/utils";

const StatsButton = ({ onClick, text = "Lifetime Stats", className = "" }) => {
  return (
    <button
      className={cn(
        "flex w-full gap-3 items-center justify-center bg-white bg-opacity-50 text-primary py-2 px-4 rounded-md font-gSemi text-base uppercase tracking-widest m-1 xs:m-0",
        className
      )}
      onClick={onClick}
      data-testid={`button-challenge`}
    >
      <LifetimeIcon height={24} width={24} />
      {text}
    </button>
  );
};

export default StatsButton;
